import styled from 'styled-components';

export const MultilineErrorContainer = styled.div`
  color: var(--color-coral-rb);
  margin-top: 20px;
`;

export const MultilineErrorList = styled.ul`
  list-style: none;
  line-height: 2;
`;
